import React, { useEffect, useState } from "react";
import {BeforeInstallPromptEvent} from "../../lib/types";

const PWAInstallButton: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isiOS, setIsiOS] = useState(false);

  useEffect(() => {
    const checkIfiOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      if (/iPhone|iPad|iPod/i.test(userAgent)) {
        setIsiOS(true);
      }
    };

    checkIfiOS();

    const handleBeforeInstallPrompt = (e: Event) => {
      const event = e as BeforeInstallPromptEvent;
      event.preventDefault(); // Prevent the default prompt
      setDeferredPrompt(event); // Save the event for triggering later
      setIsVisible(!isiOS); // Show the button only if not on iOS
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, [isiOS]);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
      setDeferredPrompt(null);
      setIsVisible(false); // Hide the button after install
    }
  };

  return (
    <>
      {isVisible && !isiOS && (
        <button
          onClick={handleInstallClick}
          className={"flex md:hidden"}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            color: "white",
            backgroundColor: "#000",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            position: "fixed",
            bottom: "10px",
            right: "50%",
            transform: "translateX(50%)",
            zIndex: 9999,
          }}
        >
          Install App
        </button>
      )}
    </>
  );
};

export default PWAInstallButton;